import { useProductsSharingsList } from "modules/sharing";
import { Pagination, SearchInput } from "ui";

import { ResellerProductsSharingsTable } from "../../components";

import styles from "./ResellerShared.module.scss";

const ResellerShared = () => {
  const {
    productsSharings,
    isLoading,
    searchValue,
    setSearchValue,
    sorting,
    setSorting,
    page,
    totalItems,
    setPage
  } = useProductsSharingsList();

  return (
    <div className={styles.resellerShared}>
      <SearchInput
        value={searchValue}
        onChange={setSearchValue}
        placeholder="Search..."
      />

      <div className={styles.resellerShared_table}>
        <ResellerProductsSharingsTable
          items={productsSharings ?? []}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
        />
      </div>

      <Pagination
        currentPage={page}
        onChange={setPage}
        totalItems={totalItems}
      />
    </div>
  );
};

export default ResellerShared;
